import { useIntl } from 'react-intl';
import Chip from '@clds/chip';
import { messages } from '../../i18n';

// istanbul ignore next
export const EarlyAccessBadge = () => {
  const { formatMessage } = useIntl();

  return <Chip variant="primary" size="xxs" label={formatMessage(messages.earlyAccessBadge)} />;
};
